module.exports = __webpack_public_path__ + "static/media/close-modal.464478d8.svg";